import { render, staticRenderFns } from "./CounterText.vue?vue&type=template&id=3e006cd7"
import script from "./CounterText.vue?vue&type=script&lang=js"
export * from "./CounterText.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports